
import EazyHeading from '@/components/EazyHeading.vue';
import getProfilePic from '@/logic/getProfilePic';
import requestAPI from '@/logic/requestBeApi';
import router from '@/router/index';

export default {
  name: 'ArrivalInfo',

  components: {
    EazyHeading,
  },

  data(): Record<string, unknown> {
    return {
      router,
      userRole: '',
      options: [
        this.$t('iArrived'),
        `${this.$t('iWillBeLate')} - 5 ${this.$t('minutes')}`,
        `${this.$t('iWillBeLate')} - 10 ${this.$t('minutes')}`,
        `${this.$t('iWillBeLate')} - 15 ${this.$t('minutes')}`,
      ],
      selectedOption: '',
      userProfilePic: require('@/assets/default-avatar.png'),
      assessmentId: this.$route.query.assessmentID,
      sendingArrivalInfo: false,
      statusComment: '',
    };
  },

  computed: {
    interactingWithBE(): boolean {
      return this.sendingArrivalInfo;
    },
  },

  async mounted(): Promise<void> {
    this.userRole = localStorage.getItem('userRole');
    await getProfilePic(this.userRole)
      .then((pic) => (this.userProfilePic = pic))
      .catch((err: Error) => err);
  },

  methods: {
    async sendArrivalInfo(): Promise<void> {
      this.sendingArrivalInfo = true;

      const userArrived = this.selectedOption === this.$t('iArrived');
      const status = userArrived ? 'arrived' : 'late';
      const statusMessage = `${this.selectedOption}. ${this.statusComment}`;
      const payload = { message: statusMessage };

      const resp = await requestAPI({
        url: `/api/v1/assessments/${this.assessmentId}/${status}`,
        method: 'PATCH',
        contentType: 'application/merge-patch+json',
        payload,
      });

      if (resp.ok) this.$message.success(this.$t('infoSentSuccess')), router.go(-1);
      else if (resp.status !== 401) this.$message.error(this.$t('someErrorOccurred'));

      this.sendingArrivalInfo = false;
    },
  },
};
